// TODO: Test the changes in here
(function() {
  'use strict';
  /* This directive is written to override the pipe function of the Smart table
  directive (stTable) */
  angular.module('ringbaPortal')
    .directive('stTable', stTable);

  function stTable(
    $filter,
    $parse
  ) {
    const directive =  {
      restrict: 'A',
      require: 'stTable',
      link: link,
      priority: -1
    };
    return directive;

    function link($scope, $element, $attrs, stTableController) {
      const tableState = stTableController.tableState();
      let filter = $filter('filter');
      const orderBy = $filter('orderBy');
      const displayGetter = $parse($attrs.stTable);
      const displaySetter = displayGetter.assign;

      stTableController.pipe = function () {
        const pagination = tableState.pagination;
        let output
          , filtered;

        const safeCopy = $parse($attrs.stSafeSrc);

        // This is to get the original array of items,
        // since the original directive doesn't store the filtered items, it always returns the unfiltered(complete) array
        // filtered = stTableController.getFilteredCollection();
        filtered = safeCopy($scope) || [];

        if (tableState.search.predicateObject) {
          _.forEach(tableState.search.predicateObject, function (value, key) {
            const obj = {};
            obj[key] = value;
            if (key !== 'customFilters') {
              filtered = $filter('filter')(filtered, obj);
            } else {
              filtered = filter(filtered, obj);
            }
          });
        }
        if (tableState.sort.predicate) {
          filtered = orderBy(filtered, tableState.sort.predicate, tableState.sort.reverse);
        }

        if ($attrs.paginate && JSON.parse($attrs.paginate) && pagination.number !== undefined) {
          pagination.numberOfPages = filtered.length > 0 ? Math.ceil(filtered.length / pagination.number) : 1;
          pagination.start = pagination.start >= filtered.length ? (pagination.numberOfPages - 1) * pagination.number : pagination.start;
          output = filtered.slice(pagination.start, pagination.start + parseInt(pagination.number));
        }
        $attrs.paginate && JSON.parse($attrs.paginate) ? displaySetter($scope, output) : displaySetter($scope, filtered);
      };

      // This is used to set a custom filter
      // Since we're overriding the pipe function and doing the filtering of items in this directive,
      // we should also set the custom filter here
      // Eg. Check Dropdown Search directive, where this has been used
      stTableController.setFilterFunction = function (filterName) {
        filter = $filter(filterName);
      };
    }
  }
})();
